__turbopack_context__.v({
  "className": "inter_67b4815f-module__2iy6kW__className",
  "variable": "inter_67b4815f-module__2iy6kW__variable",
});
